// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"84cf0fde","12":"76e494a4","535":"a915c321"}[chunkId] + ".chunk.js";
};